<template>
    <snackbar v-if="snackbar && snackbar.status" :state="snackbar" />

    <div v-if="showPendingDepartments && pendingSnackbar" class="container page notices">
        <!-- Pending Deps. -->
        <snackbar v-if="pendingSnackbar" :state="pendingSnackbar" />
    </div>
    <div v-if="notices && notices.length > 0" class="container page notices">
        <snackbar v-for="(notice, index) in notices" :key="index" :state="notice" />
    </div>
</template>

<script>
    import { ref, computed, watchEffect } from 'vue';
    import { useStore } from 'vuex';
    import { useRoute } from 'vue-router';
    import Snackbar from '@components/Snackbar/Snackbar';

    export default {
        components: {
            Snackbar,
        },
        setup() {
            const route = useRoute();
            const store = useStore();
            const snackbar = computed(() => store.getters['GlobalStore/GET_SNACKBAR']);
            const pendingDepartments = computed(() => store.getters['Departments/GET_PENDING_DEPARTMENTS']);
            const currentDepartment = computed(() => store.getters['Departments/GET_CURRENT_DEPARTMENT']);
            const showPendingDepartments = computed(() => ['account', 'certificate', 'users'].indexOf(route.name) >= 0);

            const pendingSnackbar = ref(null);
            const notices = ref([]);

            watchEffect(() => {
                // Reset notices
                notices.value = [];

                if (pendingDepartments.value.length > 0) {
                    pendingSnackbar.value = {
                        show: true,
                        static: true,
                        status: 'Success',
                        message: `${pendingDepartments.value[0].display_name} vill lägga till dig som användare`,
                        btnText: 'Acceptera',
                        btnHref: async () => {
                            await store.dispatch('Departments/ACCEPT_DEPARTMENT', {
                                method: 'accept',
                                department_id: pendingDepartments.value[0].id,
                                profile_id: pendingDepartments.value[0].user_profile.id,
                            });

                            // location.reload();
                        },
                    };
                } else {
                    pendingSnackbar.value = null;
                }

                if (currentDepartment.value && currentDepartment.value?.notices?.length > 0) {
                    currentDepartment.value.notices.forEach((notice) => {
                        if (notice.path === '' || route.path === notice.path) {
                            notices.value.push({
                                show: true,
                                static: true,
                                status: notice.type,
                                message: notice.message,
                            });
                        }
                    });
                }
            });

            return {
                notices,
                snackbar,
                pendingSnackbar,
                showPendingDepartments,
            };
        },
    };
</script>
